import { IconButton, Tooltip, type SxProps, type Theme } from '@mui/material'
import { COLOR_PRIMARY, ICON_SM } from '../common/theme'
import { BiLockAlt, BiLockOpenAlt } from 'react-icons/bi'

interface TaPadlockProps {
  isLocked: boolean
  onToggle: () => void
  question?: any
  sx?: SxProps<Theme>
}

export function TaPadlock({ isLocked, onToggle, sx }: TaPadlockProps) {
  return <Tooltip title={isLocked ? 'Locked' : 'Unlocked'}>
    <IconButton
      size="small"
      onClick={onToggle}
      sx={[
        { p: 0.375, color: isLocked ? COLOR_PRIMARY : 'text.disabled' },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {isLocked
        ? <BiLockAlt size={ICON_SM} />
        : <BiLockOpenAlt size={ICON_SM} />}
    </IconButton>
  </Tooltip>
}

export default TaPadlock
